module.exports = __webpack_public_path__ + "img/4f4ee51.jpg";